import { supabase } from '../lib/supabaseClient';

export type SuperAdminTrialState = 'all' | 'active' | 'expired' | 'none';

export interface SuperAdminAccess {
  role: string;
}

export interface SuperAdminSalonSummary {
  salon_id: string;
  salon_name: string;
  account_email: string;
  created_at: string | null;
  billing_status: string | null;
  plan_code: string | null;
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  trial_starts_at: string | null;
  trial_ends_at: string | null;
  seat_limit: number | null;
  active_user_count: number;
  primary_admin_first_name: string | null;
  primary_admin_last_name: string | null;
  total_count: number;
}

export async function getSuperAdminAccess(): Promise<SuperAdminAccess> {
  const { data, error } = await supabase.rpc('admin_get_access_v1');

  if (error) {
    throw error;
  }

  const row = Array.isArray(data) ? data[0] : null;
  if (!row?.role) {
    throw new Error('Forbidden');
  }

  return { role: String(row.role) };
}

export async function listSuperAdminSalons(params: {
  search?: string;
  billingStatus?: string;
  trialState?: SuperAdminTrialState;
  limit?: number;
  offset?: number;
}): Promise<SuperAdminSalonSummary[]> {
  const { data, error } = await supabase.rpc('admin_list_salons_v1', {
    p_search: params.search?.trim() || null,
    p_billing_status: params.billingStatus?.trim() || null,
    p_trial_state: params.trialState ?? 'all',
    p_limit: params.limit ?? 25,
    p_offset: params.offset ?? 0,
  });

  if (error) {
    throw error;
  }

  return (Array.isArray(data) ? data : []) as SuperAdminSalonSummary[];
}